import { render, staticRenderFns } from "./importRoutePage.vue?vue&type=template&id=5addb547&scoped=true"
import script from "./importRoutePage.vue?vue&type=script&lang=js"
export * from "./importRoutePage.vue?vue&type=script&lang=js"
import style0 from "./importRoutePage.vue?vue&type=style&index=0&id=5addb547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5addb547",
  null
  
)

export default component.exports